import React from 'react';
import { FormFieldParams } from './FormField';

const FormFieldRow = ({ cssName, children }: FormFieldParams): JSX.Element => {
    const rowCss = 'fieldset-row ' + (cssName ? cssName : '');
    return <div className={rowCss}>{children}</div>;
};

export default FormFieldRow;
